import React from 'react'
import PropTypes from 'prop-types'
import { Price } from '@deseretbook/react-ui'

const PlatinumPointsDisplay = ({ points, ...rest }) => <Price value={points / 100} {...rest} />

PlatinumPointsDisplay.propTypes = {
  points: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

PlatinumPointsDisplay.defaultProps = {
  points: 0,
}

export default PlatinumPointsDisplay
